import { Component } from "react";
import { connect } from "react-redux";
import { Outlet } from "react-router";

class LogInIndex extends Component {
  render() {
    return (
      <div>
        <Outlet />
      </div>
    );
  }
}

const mapDispatchToProps = {};
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(LogInIndex);
